"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M15 7H5a3 3 0 000 6h10a3 3 0 100-6zM5 5a5 5 0 000 10h10a5 5 0 000-10H5z"];
//# sourceMappingURL=stadium-geometry.js.map